export default `:host {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: var(--ids-space-md);
  width: 100%;
  box-sizing: border-box;
  align-items: start;
}

:host([hidden]) {
  display: none;
}

:host([enable-container]) {
  container-type: inline-size;
}

:host([align-items=anchor-center]) {
  align-items: anchor-center;
}

:host([align-items=center]) {
  align-items: center;
}

:host([align-items=baseline]) {
  align-items: baseline;
}

:host([align-items=end]) {
  align-items: end;
}

:host([align-items=start]) {
  align-items: start;
}

:host([label-position=inline-start][align-items=start]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-30);
}

:host([label-position=inline-start][align-items=start][compact]),
:host([label-position=inline-start][align-items=start][field-height=xs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-10);
}

:host([label-position=inline-start][align-items=start][field-height=sm]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-20);
}

:host([label-position=inline-start][align-items=start][field-height=lg]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-40);
}

:host([label-position=top][align-items=start]),
:host(:not([label-position])[align-items=start]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-30);
  --ids-checkbox-top-margin: 20px;
}

:host([label-position=top][align-items=start][compact]),
:host([label-position=top][align-items=start][field-height=xs]),
:host(:not([label-position])[align-items=start][compact]),
:host(:not([label-position])[align-items=start][field-height=xs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-10);
  --ids-checkbox-top-margin: 18px;
}

:host([label-position=top][align-items=start][field-height=sm]),
:host(:not([label-position])[align-items=start][field-height=sm]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-20);
  --ids-checkbox-top-margin: 20px;
}

:host([label-position=top][align-items=start][field-height=lg]),
:host(:not([label-position])[align-items=start][field-height=lg]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-40);
  --ids-checkbox-top-margin: 20px;
}

:host([cols="1"]),
.ids-form-layout-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

:host([cols="2"]),
.ids-form-layout-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

:host([cols="3"]),
.ids-form-layout-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

:host([cols="4"]),
.ids-form-layout-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

:host([cols="5"]),
.ids-form-layout-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

:host([cols="6"]),
.ids-form-layout-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

:host([cols="7"]),
.ids-form-layout-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

:host([cols="8"]),
.ids-form-layout-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

:host([cols="9"]),
.ids-form-layout-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

:host([cols="10"]),
.ids-form-layout-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}

:host([cols="11"]),
.ids-form-layout-cols-11 {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}

:host([cols="12"]),
.ids-form-layout-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

:host([gap=none]),
.ids-form-layout-gap-none {
  gap: 0;
}

:host([gap="2xs"]),
.ids-form-layout-gap-2xs {
  gap: var(--ids-space-2xs);
}

:host([gap=xs]),
.ids-form-layout-gap-xs {
  gap: var(--ids-space-xs);
}

:host([gap=sm]),
.ids-form-layout-gap-sm {
  gap: var(--ids-space-sm);
}

:host([gap=md]),
.ids-form-layout-gap-md {
  gap: var(--ids-space-md);
}

:host([gap=lg]),
.ids-form-layout-gap-lg {
  gap: var(--ids-space-lg);
}

:host([gap=xl]),
.ids-form-layout-gap-xl {
  gap: var(--ids-space-xl);
}

:host([row-gap=none]),
.ids-form-layout-row-gap-none {
  row-gap: 0;
}

:host([row-gap=sm]),
.ids-form-layout-row-gap-sm {
  row-gap: var(--ids-space-sm);
}

:host([row-gap=md]),
.ids-form-layout-row-gap-md {
  row-gap: var(--ids-space-md);
}

:host([row-gap=lg]),
.ids-form-layout-row-gap-lg {
  row-gap: var(--ids-space-lg);
}

:host([row-gap=xl]),
.ids-form-layout-row-gap-xl {
  row-gap: var(--ids-space-xl);
}

:host([col-gap=none]),
.ids-form-layout-col-gap-none {
  column-gap: 0;
}

:host([col-gap=sm]),
.ids-form-layout-col-gap-sm {
  column-gap: var(--ids-space-sm);
}

:host([col-gap=md]),
.ids-form-layout-col-gap-md {
  column-gap: var(--ids-space-md);
}

:host([col-gap=lg]),
.ids-form-layout-col-gap-lg {
  column-gap: var(--ids-space-lg);
}

:host([col-gap=xl]),
.ids-form-layout-col-gap-xl {
  column-gap: var(--ids-space-xl);
}

@media (width >= 0) {
  :host([cols-xs="1"]:not([enable-container])),
  .ids-form-layout-cols-xs-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xs="2"]:not([enable-container])),
  .ids-form-layout-cols-xs-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xs="3"]:not([enable-container])),
  .ids-form-layout-cols-xs-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xs="4"]:not([enable-container])),
  .ids-form-layout-cols-xs-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xs="5"]:not([enable-container])),
  .ids-form-layout-cols-xs-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xs="6"]:not([enable-container])),
  .ids-form-layout-cols-xs-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xs="7"]:not([enable-container])),
  .ids-form-layout-cols-xs-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xs="8"]:not([enable-container])),
  .ids-form-layout-cols-xs-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xs="9"]:not([enable-container])),
  .ids-form-layout-cols-xs-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xs="10"]:not([enable-container])),
  .ids-form-layout-cols-xs-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xs="11"]:not([enable-container])),
  .ids-form-layout-cols-xs-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xs="12"]:not([enable-container])),
  .ids-form-layout-cols-xs-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 767px) {
  :host([cols-sm="1"]:not([enable-container])),
  .ids-form-layout-cols-sm-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-sm="2"]:not([enable-container])),
  .ids-form-layout-cols-sm-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-sm="3"]:not([enable-container])),
  .ids-form-layout-cols-sm-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-sm="4"]:not([enable-container])),
  .ids-form-layout-cols-sm-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-sm="5"]:not([enable-container])),
  .ids-form-layout-cols-sm-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-sm="6"]:not([enable-container])),
  .ids-form-layout-cols-sm-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-sm="7"]:not([enable-container])),
  .ids-form-layout-cols-sm-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-sm="8"]:not([enable-container])),
  .ids-form-layout-cols-sm-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-sm="9"]:not([enable-container])),
  .ids-form-layout-cols-sm-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-sm="10"]:not([enable-container])),
  .ids-form-layout-cols-sm-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-sm="11"]:not([enable-container])),
  .ids-form-layout-cols-sm-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-sm="12"]:not([enable-container])),
  .ids-form-layout-cols-sm-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 927px) {
  :host([cols-md="1"]:not([enable-container])),
  .ids-form-layout-cols-md-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-md="2"]:not([enable-container])),
  .ids-form-layout-cols-md-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-md="3"]:not([enable-container])),
  .ids-form-layout-cols-md-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-md="4"]:not([enable-container])),
  .ids-form-layout-cols-md-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-md="5"]:not([enable-container])),
  .ids-form-layout-cols-md-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-md="6"]:not([enable-container])),
  .ids-form-layout-cols-md-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-md="7"]:not([enable-container])),
  .ids-form-layout-cols-md-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-md="8"]:not([enable-container])),
  .ids-form-layout-cols-md-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-md="9"]:not([enable-container])),
  .ids-form-layout-cols-md-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-md="10"]:not([enable-container])),
  .ids-form-layout-cols-md-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-md="11"]:not([enable-container])),
  .ids-form-layout-cols-md-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-md="12"]:not([enable-container])),
  .ids-form-layout-cols-md-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 928px) {
  :host([cols-lg="1"]:not([enable-container])),
  .ids-form-layout-cols-lg-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-lg="2"]:not([enable-container])),
  .ids-form-layout-cols-lg-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-lg="3"]:not([enable-container])),
  .ids-form-layout-cols-lg-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-lg="4"]:not([enable-container])),
  .ids-form-layout-cols-lg-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-lg="5"]:not([enable-container])),
  .ids-form-layout-cols-lg-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-lg="6"]:not([enable-container])),
  .ids-form-layout-cols-lg-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-lg="7"]:not([enable-container])),
  .ids-form-layout-cols-lg-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-lg="8"]:not([enable-container])),
  .ids-form-layout-cols-lg-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-lg="9"]:not([enable-container])),
  .ids-form-layout-cols-lg-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-lg="10"]:not([enable-container])),
  .ids-form-layout-cols-lg-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-lg="11"]:not([enable-container])),
  .ids-form-layout-cols-lg-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-lg="12"]:not([enable-container])),
  .ids-form-layout-cols-lg-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 1183px) {
  :host([cols-xl="1"]:not([enable-container])),
  .ids-form-layout-cols-xl-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xl="2"]:not([enable-container])),
  .ids-form-layout-cols-xl-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xl="3"]:not([enable-container])),
  .ids-form-layout-cols-xl-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xl="4"]:not([enable-container])),
  .ids-form-layout-cols-xl-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xl="5"]:not([enable-container])),
  .ids-form-layout-cols-xl-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xl="6"]:not([enable-container])),
  .ids-form-layout-cols-xl-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xl="7"]:not([enable-container])),
  .ids-form-layout-cols-xl-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xl="8"]:not([enable-container])),
  .ids-form-layout-cols-xl-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xl="9"]:not([enable-container])),
  .ids-form-layout-cols-xl-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xl="10"]:not([enable-container])),
  .ids-form-layout-cols-xl-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xl="11"]:not([enable-container])),
  .ids-form-layout-cols-xl-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xl="12"]:not([enable-container])),
  .ids-form-layout-cols-xl-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@media (width >= 2463px) {
  :host([cols-xxl="1"]:not([enable-container])),
  .ids-form-layout-cols-xxl-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xxl="2"]:not([enable-container])),
  .ids-form-layout-cols-xxl-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xxl="3"]:not([enable-container])),
  .ids-form-layout-cols-xxl-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xxl="4"]:not([enable-container])),
  .ids-form-layout-cols-xxl-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xxl="5"]:not([enable-container])),
  .ids-form-layout-cols-xxl-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xxl="6"]:not([enable-container])),
  .ids-form-layout-cols-xxl-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xxl="7"]:not([enable-container])),
  .ids-form-layout-cols-xxl-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xxl="8"]:not([enable-container])),
  .ids-form-layout-cols-xxl-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xxl="9"]:not([enable-container])),
  .ids-form-layout-cols-xxl-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xxl="10"]:not([enable-container])),
  .ids-form-layout-cols-xxl-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xxl="11"]:not([enable-container])),
  .ids-form-layout-cols-xxl-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xxl="12"]:not([enable-container])),
  .ids-form-layout-cols-xxl-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 0) {
  :host([cols-xs="1"]) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xs="2"]) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xs="3"]) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xs="4"]) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xs="5"]) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xs="6"]) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xs="7"]) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xs="8"]) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xs="9"]) {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xs="10"]) {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xs="11"]) {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xs="12"]) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 767px) {
  :host([cols-sm="1"]) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-sm="2"]) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-sm="3"]) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-sm="4"]) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-sm="5"]) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-sm="6"]) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-sm="7"]) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-sm="8"]) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-sm="9"]) {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-sm="10"]) {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-sm="11"]) {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-sm="12"]) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 927px) {
  :host([cols-md="1"]) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-md="2"]) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-md="3"]) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-md="4"]) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-md="5"]) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-md="6"]) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-md="7"]) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-md="8"]) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-md="9"]) {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-md="10"]) {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-md="11"]) {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-md="12"]) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 928px) {
  :host([cols-lg="1"]) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-lg="2"]) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-lg="3"]) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-lg="4"]) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-lg="5"]) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-lg="6"]) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-lg="7"]) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-lg="8"]) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-lg="9"]) {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-lg="10"]) {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-lg="11"]) {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-lg="12"]) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 1183px) {
  :host([cols-xl="1"]) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xl="2"]) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xl="3"]) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xl="4"]) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xl="5"]) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xl="6"]) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xl="7"]) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xl="8"]) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xl="9"]) {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xl="10"]) {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xl="11"]) {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xl="12"]) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
@container (width >= 2463px) {
  :host([cols-xxl="1"]) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  :host([cols-xxl="2"]) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host([cols-xxl="3"]) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host([cols-xxl="4"]) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host([cols-xxl="5"]) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  :host([cols-xxl="6"]) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  :host([cols-xxl="7"]) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  :host([cols-xxl="8"]) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  :host([cols-xxl="9"]) {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }
  :host([cols-xxl="10"]) {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
  :host([cols-xxl="11"]) {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  :host([cols-xxl="12"]) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}
::slotted([col-span="1"]) {
  grid-column: span 1;
}

::slotted([col-span="2"]) {
  grid-column: span 2;
}

::slotted([col-span="3"]) {
  grid-column: span 3;
}

::slotted([col-span="4"]) {
  grid-column: span 4;
}

::slotted([col-span="5"]) {
  grid-column: span 5;
}

::slotted([col-span="6"]) {
  grid-column: span 6;
}

::slotted([col-span="7"]) {
  grid-column: span 7;
}

::slotted([col-span="8"]) {
  grid-column: span 8;
}

::slotted([col-span="9"]) {
  grid-column: span 9;
}

::slotted([col-span="10"]) {
  grid-column: span 10;
}

::slotted([col-span="11"]) {
  grid-column: span 11;
}

::slotted([col-span="12"]) {
  grid-column: span 12;
}

@media (width >= 0) {
  :host(:not([enable-container])) ::slotted([col-span-xs="1"]) {
    grid-column: span 1;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="2"]) {
    grid-column: span 2;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="3"]) {
    grid-column: span 3;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="4"]) {
    grid-column: span 4;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="5"]) {
    grid-column: span 5;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="6"]) {
    grid-column: span 6;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="7"]) {
    grid-column: span 7;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="8"]) {
    grid-column: span 8;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="9"]) {
    grid-column: span 9;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="10"]) {
    grid-column: span 10;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="11"]) {
    grid-column: span 11;
  }
  :host(:not([enable-container])) ::slotted([col-span-xs="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 767px) {
  :host(:not([enable-container])) ::slotted([col-span-sm="1"]) {
    grid-column: span 1;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="2"]) {
    grid-column: span 2;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="3"]) {
    grid-column: span 3;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="4"]) {
    grid-column: span 4;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="5"]) {
    grid-column: span 5;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="6"]) {
    grid-column: span 6;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="7"]) {
    grid-column: span 7;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="8"]) {
    grid-column: span 8;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="9"]) {
    grid-column: span 9;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="10"]) {
    grid-column: span 10;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="11"]) {
    grid-column: span 11;
  }
  :host(:not([enable-container])) ::slotted([col-span-sm="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 927px) {
  :host(:not([enable-container])) ::slotted([col-span-md="1"]) {
    grid-column: span 1;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="2"]) {
    grid-column: span 2;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="3"]) {
    grid-column: span 3;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="4"]) {
    grid-column: span 4;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="5"]) {
    grid-column: span 5;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="6"]) {
    grid-column: span 6;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="7"]) {
    grid-column: span 7;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="8"]) {
    grid-column: span 8;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="9"]) {
    grid-column: span 9;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="10"]) {
    grid-column: span 10;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="11"]) {
    grid-column: span 11;
  }
  :host(:not([enable-container])) ::slotted([col-span-md="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 928px) {
  :host(:not([enable-container])) ::slotted([col-span-lg="1"]) {
    grid-column: span 1;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="2"]) {
    grid-column: span 2;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="3"]) {
    grid-column: span 3;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="4"]) {
    grid-column: span 4;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="5"]) {
    grid-column: span 5;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="6"]) {
    grid-column: span 6;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="7"]) {
    grid-column: span 7;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="8"]) {
    grid-column: span 8;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="9"]) {
    grid-column: span 9;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="10"]) {
    grid-column: span 10;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="11"]) {
    grid-column: span 11;
  }
  :host(:not([enable-container])) ::slotted([col-span-lg="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 1183px) {
  :host(:not([enable-container])) ::slotted([col-span-xl="1"]) {
    grid-column: span 1;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="2"]) {
    grid-column: span 2;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="3"]) {
    grid-column: span 3;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="4"]) {
    grid-column: span 4;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="5"]) {
    grid-column: span 5;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="6"]) {
    grid-column: span 6;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="7"]) {
    grid-column: span 7;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="8"]) {
    grid-column: span 8;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="9"]) {
    grid-column: span 9;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="10"]) {
    grid-column: span 10;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="11"]) {
    grid-column: span 11;
  }
  :host(:not([enable-container])) ::slotted([col-span-xl="12"]) {
    grid-column: span 12;
  }
}
@media (width >= 2463px) {
  :host(:not([enable-container])) ::slotted([col-span-xxl="1"]) {
    grid-column: span 1;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="2"]) {
    grid-column: span 2;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="3"]) {
    grid-column: span 3;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="4"]) {
    grid-column: span 4;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="5"]) {
    grid-column: span 5;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="6"]) {
    grid-column: span 6;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="7"]) {
    grid-column: span 7;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="8"]) {
    grid-column: span 8;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="9"]) {
    grid-column: span 9;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="10"]) {
    grid-column: span 10;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="11"]) {
    grid-column: span 11;
  }
  :host(:not([enable-container])) ::slotted([col-span-xxl="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 0) {
  ::slotted([col-span-xs="1"]) {
    grid-column: span 1;
  }
  ::slotted([col-span-xs="2"]) {
    grid-column: span 2;
  }
  ::slotted([col-span-xs="3"]) {
    grid-column: span 3;
  }
  ::slotted([col-span-xs="4"]) {
    grid-column: span 4;
  }
  ::slotted([col-span-xs="5"]) {
    grid-column: span 5;
  }
  ::slotted([col-span-xs="6"]) {
    grid-column: span 6;
  }
  ::slotted([col-span-xs="7"]) {
    grid-column: span 7;
  }
  ::slotted([col-span-xs="8"]) {
    grid-column: span 8;
  }
  ::slotted([col-span-xs="9"]) {
    grid-column: span 9;
  }
  ::slotted([col-span-xs="10"]) {
    grid-column: span 10;
  }
  ::slotted([col-span-xs="11"]) {
    grid-column: span 11;
  }
  ::slotted([col-span-xs="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 767px) {
  ::slotted([col-span-sm="1"]) {
    grid-column: span 1;
  }
  ::slotted([col-span-sm="2"]) {
    grid-column: span 2;
  }
  ::slotted([col-span-sm="3"]) {
    grid-column: span 3;
  }
  ::slotted([col-span-sm="4"]) {
    grid-column: span 4;
  }
  ::slotted([col-span-sm="5"]) {
    grid-column: span 5;
  }
  ::slotted([col-span-sm="6"]) {
    grid-column: span 6;
  }
  ::slotted([col-span-sm="7"]) {
    grid-column: span 7;
  }
  ::slotted([col-span-sm="8"]) {
    grid-column: span 8;
  }
  ::slotted([col-span-sm="9"]) {
    grid-column: span 9;
  }
  ::slotted([col-span-sm="10"]) {
    grid-column: span 10;
  }
  ::slotted([col-span-sm="11"]) {
    grid-column: span 11;
  }
  ::slotted([col-span-sm="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 927px) {
  ::slotted([col-span-md="1"]) {
    grid-column: span 1;
  }
  ::slotted([col-span-md="2"]) {
    grid-column: span 2;
  }
  ::slotted([col-span-md="3"]) {
    grid-column: span 3;
  }
  ::slotted([col-span-md="4"]) {
    grid-column: span 4;
  }
  ::slotted([col-span-md="5"]) {
    grid-column: span 5;
  }
  ::slotted([col-span-md="6"]) {
    grid-column: span 6;
  }
  ::slotted([col-span-md="7"]) {
    grid-column: span 7;
  }
  ::slotted([col-span-md="8"]) {
    grid-column: span 8;
  }
  ::slotted([col-span-md="9"]) {
    grid-column: span 9;
  }
  ::slotted([col-span-md="10"]) {
    grid-column: span 10;
  }
  ::slotted([col-span-md="11"]) {
    grid-column: span 11;
  }
  ::slotted([col-span-md="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 928px) {
  ::slotted([col-span-lg="1"]) {
    grid-column: span 1;
  }
  ::slotted([col-span-lg="2"]) {
    grid-column: span 2;
  }
  ::slotted([col-span-lg="3"]) {
    grid-column: span 3;
  }
  ::slotted([col-span-lg="4"]) {
    grid-column: span 4;
  }
  ::slotted([col-span-lg="5"]) {
    grid-column: span 5;
  }
  ::slotted([col-span-lg="6"]) {
    grid-column: span 6;
  }
  ::slotted([col-span-lg="7"]) {
    grid-column: span 7;
  }
  ::slotted([col-span-lg="8"]) {
    grid-column: span 8;
  }
  ::slotted([col-span-lg="9"]) {
    grid-column: span 9;
  }
  ::slotted([col-span-lg="10"]) {
    grid-column: span 10;
  }
  ::slotted([col-span-lg="11"]) {
    grid-column: span 11;
  }
  ::slotted([col-span-lg="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 1183px) {
  ::slotted([col-span-xl="1"]) {
    grid-column: span 1;
  }
  ::slotted([col-span-xl="2"]) {
    grid-column: span 2;
  }
  ::slotted([col-span-xl="3"]) {
    grid-column: span 3;
  }
  ::slotted([col-span-xl="4"]) {
    grid-column: span 4;
  }
  ::slotted([col-span-xl="5"]) {
    grid-column: span 5;
  }
  ::slotted([col-span-xl="6"]) {
    grid-column: span 6;
  }
  ::slotted([col-span-xl="7"]) {
    grid-column: span 7;
  }
  ::slotted([col-span-xl="8"]) {
    grid-column: span 8;
  }
  ::slotted([col-span-xl="9"]) {
    grid-column: span 9;
  }
  ::slotted([col-span-xl="10"]) {
    grid-column: span 10;
  }
  ::slotted([col-span-xl="11"]) {
    grid-column: span 11;
  }
  ::slotted([col-span-xl="12"]) {
    grid-column: span 12;
  }
}
@container (width >= 2463px) {
  ::slotted([col-span-xxl="1"]) {
    grid-column: span 1;
  }
  ::slotted([col-span-xxl="2"]) {
    grid-column: span 2;
  }
  ::slotted([col-span-xxl="3"]) {
    grid-column: span 3;
  }
  ::slotted([col-span-xxl="4"]) {
    grid-column: span 4;
  }
  ::slotted([col-span-xxl="5"]) {
    grid-column: span 5;
  }
  ::slotted([col-span-xxl="6"]) {
    grid-column: span 6;
  }
  ::slotted([col-span-xxl="7"]) {
    grid-column: span 7;
  }
  ::slotted([col-span-xxl="8"]) {
    grid-column: span 8;
  }
  ::slotted([col-span-xxl="9"]) {
    grid-column: span 9;
  }
  ::slotted([col-span-xxl="10"]) {
    grid-column: span 10;
  }
  ::slotted([col-span-xxl="11"]) {
    grid-column: span 11;
  }
  ::slotted([col-span-xxl="12"]) {
    grid-column: span 12;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
